import { render, staticRenderFns } from "./ConfigurationName.vue?vue&type=template&id=387e4942&"
import script from "./ConfigurationName.vue?vue&type=script&lang=js&"
export * from "./ConfigurationName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports